import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import MessageIcons from '../../../../../enums/MessageIcons';
import MessageType from '../../../../../enums/MessageType';
import Language from '../../../../lang/language';
import Spacing from '../../../../style-helper/Spacing';

const useStyles = createUseStyles({
  infoIcon: {
    fill: props => ((props.isArtemisIcon && props.theme.colors?.[MessageType.INFO]?.base)
      ? props.theme.colors[MessageType.INFO].base : props.theme.core.messageColours[MessageType.INFO].foreground),
    verticalAlign: 'middle',
    marginRight: props => props.rightMargin && Spacing.single,
  },
});

export default function InfoIcon(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const altText = Language.getText('accessibility.icon.alt.info');
  
  switch (theme.core.messageIconStyles[MessageType.INFO]) {
    case MessageIcons.ROUND:
      return (
        <svg
          className={classes.infoIcon}
          data-test="InfoIcon__round"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 1 24 24"
          title={altText}
        >
          <defs>
            <path
              id="info-icn-a"
              d="M12,0.210122449 C18.62905,0.210122449 24,5.47053061 24,11.9647347 C24,18.4589388 18.62905,23.7203265 12,23.7203265 C5.37045,23.7203265 0,18.4589388 0,11.9647347 C0,5.47053061 5.37045,0.210122449 12,0.210122449 Z"
            />
            <path
              id="info-icn-c"
              d="M1.50055,5.44417327 C2.30254643,5.44417327 2.95209445,6.07549033 2.99746778,6.87951451 L3,6.96953796 L3,14.5851612 L2.99746778,14.6751827 C2.95209445,15.479668 2.30254643,16.1238976 1.50055,16.1105259 C0.698023214,16.1105259 0.0479448342,15.4787129 0.00253429528,14.6751315 L0,14.5851612 L0,6.96953796 C0,6.12312056 0.6683,5.44417327 1.50055,5.44417327 Z M1.50055,0.110730309 C2.33225,0.110730309 3,0.822744945 3,1.7107632 C3,2.59771476 2.33225,3.31079609 1.50055,3.31079609 C0.6683,3.31079609 0,2.59771476 0,1.7107632 C0,0.822744945 0.6683,0.110730309 1.50055,0.110730309 Z"
            />
          </defs>
          <g fill="none" fillRule="evenodd" transform="translate(0 .97)">
            <mask id="info-icn-b" fill="#fff">
              <use xlinkHref="#info-icn-a" />
            </mask>
            <polygon fill="#007ac9" points="-5 -4.688 29 -4.688 29 28.618 -5 28.618" mask="url(#info-icn-b)" />
            <g transform="translate(10 3.918)">
              <mask id="info-icn-d" fill="#fff">
                <use xlinkHref="#info-icn-c" />
              </mask>
              <polygon fill="#fffefe" points="-5 -4.889 8 -4.889 8 22.111 -5 22.111" mask="url(#info-icn-d)" />
            </g>
          </g>
        </svg>
      );
    case MessageIcons.DEFAULT:
    default:
      return (
        <svg
          className={classes.infoIcon}
          data-test="InfoIcon__default"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          title={altText}
        >
          <path
            fillRule="evenodd"
            d={'M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 '
            + '4.477 0 10 0zm1 9H9v7h2V9zm-1-5c-.863 0-1.5.65-1.5 1.506C8.5 6.35 9.137 7 10 7s1.5-.65 1.5-1.494C11.5 4.65 '
            + '10.863 4 10 4z'}
          />
        </svg>
      );
  }
}

InfoIcon.propTypes = {
  isArtemisIcon: PropTypes.bool,
  rightMargin: PropTypes.bool,
};
